module.exports = __webpack_public_path__ + "img/1.c512bd1e.jpg";